import { useCallback, useState } from 'react';
import NewServiceAccounts from './screens/ServiceAccounts';
import { ServiceAccountProvider } from './contexts/ServiceAccountContext';
import SmartPolicies from './screens/SmartPolicies/SmartPolicies';
import { SmartPolicyProvider } from './screens/SmartPolicies/SmartPolicyContext';

const ServiceAccountWrapper = () => {
    const [showServiceAccount, setShowServiceAccount] = useState(true);
    const returnToServiceAccount = useCallback(() => {
        setShowServiceAccount(true);
    }, []);

    const openSmartPolicies = () => {
        setShowServiceAccount(false);
    };

    return (
        <SmartPolicyProvider>
            <>
                {!showServiceAccount ? (
                    <SmartPolicies returnToMainPage={returnToServiceAccount} />
                ) : (
                    <ServiceAccountProvider>
                        <NewServiceAccounts openSmartPolicies={openSmartPolicies} />
                    </ServiceAccountProvider>
                )}
            </>
        </SmartPolicyProvider>
    );
};
export default ServiceAccountWrapper;
